module.exports = __webpack_public_path__ + "static/start-small-stay-small-971a74dfd8fd39ace9ed5a975bcc7909.jpg";